export default __webpack_public_path__ + "static/media/hero.b97dc93f.svg";